import { GoogleAnalyticsService } from '@grupoboticario/barril-del-chavo'

export enum StepsEnum {
  STEP_1 = 'step-1:inicio',
  STEP_2 = 'step-2:pin',
  STEP_3 = 'step-3:menu',
  STEP_4 = 'step-4:sacola',
  STEP_5 = 'step-5:final',
}
interface trackOnboardingGAEventsParams {
  cd_interaction_detail: string
  cd_step: StepsEnum
}

export const trackOnboardingGAEvents = ({
  cd_interaction_detail,
  cd_step,
}: trackOnboardingGAEventsParams) => {
  const eventData = {
    event: 'analytics-event',
    event_parameters: {
      event_name: 'interaction_modal_onboarding',
      cd_interaction_detail: cd_interaction_detail,
      cd_step: cd_step,
    },
  }

  GoogleAnalyticsService.event(eventData)
}
